<template>
  <a-modal
    title="提交黑名单"
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :confirmLoading="confirmLoading"
  >
    <a-alert :style="{marginBottom:'10px'}" type="info" closable>
      <span slot="message">加入黑名单库后，系统将会进行全网公开，您可以在全网黑名单库看到该会员信息!</span>
    </a-alert>
    <a-form :form="form">
      <!-- <a-form-item label="微信ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['wxid',{rules: [{ required: true, message: '必填项' }]}]" read-only />
      </a-form-item> -->
      <a-form-item label="提交类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          v-decorator="['type',{ rules: [{ required: true, message: '必填项' }]}]"
          placeholder="必填"
        >
          <a-select-option :value="1">未知</a-select-option>
          <a-select-option :value="2">店淘店铺</a-select-option>
          <a-select-option :value="3">短信偷粉</a-select-option>
          <a-select-option :value="4">快递卡片偷粉</a-select-option>
          <a-select-option :value="5">店铺群偷粉</a-select-option>
          <a-select-option :value="6">其他</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="提交理由" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea placeholder="可选" :rows="4" v-decorator="['remark']" />
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess" :loading="confirmLoading">发送</a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import OrderApi from '@/api/order-new'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      form: this.$form.createForm(this),
      data: {},
      robotid: null,
      confirmLoading: false,
      store_name:'',
      seller_nick:''
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show(robotid, data) {
      this.visible = true
      this.robotid = robotid
      this.data = data
      this.store_name=data.seller_shop_title
      this.seller_nick=data.seller_nick
      this.$nextTick(() => {
        this.form.setFieldsValue({
          wxid: data.wxid
        })
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleSeccess() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = this.data
          // const obj = {
          //   nickname: data.nickname,
          //   avatar: data.avatar,
          //   order_date: data.order_date,
          //   order_num: data.order_num,
          //   order_sixbit: data.order_sixbit,
          //   regtime: data.regtime,
          //   uid: data.uid,
          //   username: data.username,
          //   usertype: data.usertype,
          //   wxid: data.wxid
          // }
          this.confirmLoading = true
          OrderApi.addBlackList({ 
                sub_id: this.robotid, 
                source: 1, 
                store_name:this.store_name,
                type: values.type,
                remark: values.remark ,
                seller_nick:this.seller_nick
            }).then(res => {
              if (res.code === 1) {
                this.$message.success('提交成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    msg(wxid){
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: this.currentRobotId,
        type: 'operationfans',
        data: {
          wxid: wxid,
          type: 1
        }
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    }
  }
}
</script>
<style lang="less">
</style>
